import { DeletingChip } from '../../components/DeletingChip';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function BatchActionsCellRenderer({ data, node, context }: any) {
  if (!data || node?.rowPinned) return null;
  if (data.status === 'Deleting') return <DeletingChip />;
  return (
    <>
      <button type="button" className="btn btn-default btn-xs" onClick={() => context.openAssign(data)}>
        <i className="fas fa-share" aria-hidden="true" /> Assign
      </button>{' '}
      <button type="button" className="btn btn-default btn-xs" onClick={() => context.openEdit(data)}>
        <i className="fas fa-pencil-alt" aria-hidden="true" /> Edit
      </button>{' '}
      <button type="button" className="btn btn-xs btn-danger" onClick={() => context.openDelete(data)}>
        <i className="fas fa-trash" aria-hidden="true" /> Delete
      </button>
    </>
  );
}
